import { JSCodePrettifier } from './JSCodePrettifier';

export default JSCodePrettifier;